// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2timT","actions":"GroupTable_actions__3VZoO","deleteModalFooter":"GroupTable_deleteModalFooter__3xsbe"};